import { useState } from "react";
import { Column } from "../../../Components/Tables/Table";
import { formatDate, formatNumber } from "../../../Utility/Utility";
import AsnDetail from "../Detail/Detail";
import { ASN, Line } from "../model/asnOverview.model";

export default function AsnOverview() {
  const screenName = "ASN";
  const addUrl = "/inbound/asn/overview/add";
  const listUrl = "/inbound/asn/overview";
  const isHistoryEnabled = true;
  const noOfrowsToDisplay = 3;
  const [showViewModal, setViewModal] = useState(false);
  const [data, setData] = useState<ASN | null>(null);

  const handelViewMoreAction = (data: any) => {
    setViewModal(true);
  };

  const columns: Column[] = [
    {
      name: "Line #",
      selector: (row: Line) => row.line_number,
    },
    {
      name: "Item Code",
      selector: (row: Line) => (
        <div>
          {row.item?.attachments?.length !== 0 ? (
            <img
              // src={require(`../../../assets/images/${row.item.attachments}`)}
              alt={row.item?.code ?? ""}
              style={{ width: "20px", marginRight: "8px" }}
            />
          ) : (
            <></>
          )}
          {row.item?.code ?? ""}
        </div>
      ),
    },
    {
      name: "Item Name",
      selector: (row: Line) => (
        <span
          title={
            row.item?.name && row.item.name.length > 15
              ? row.item.name
              : ""
          }
        >
          {row.item?.name && row.item.name.length > 15
            ? `${row.item.name.slice(0, 15)}...`
            : row.item?.name}
        </span>
      ),
    },
    {
      name: "UOM",
      selector: (row: Line) => row.uom_code,
    },
    {
      name: "Expected Qty",
      selector: (row: Line) => formatNumber(row.qty_expected),
    },
    {
      name: "Received Qty",
      selector: (row: Line) => formatNumber(row.qty_received),
    },
  ];
  const InboundASNOverviewData = {
    ASNOverviewExpanded: [
      { label: "Client", value: `${data?.client?.name}(${data?.client?.code})` },
      { label: "ASN #", value: data?.id},
      {
        label: "Tracking #",
        value: <div className="w-fit">{data?.tracking_number}</div>,
      },
      { label: "Reference 1", value: data?.reference_1 },
      { label: "Reference 2", value: data?.reference_2 },
      {
        label: "Expected Date",
        value: data?.expected_arrival_date
          ? formatDate(data?.expected_arrival_date)
          : "",
      },
      { label: "Carrier Name", value: data?.carrier?.name },
      {
        label: "Created On",
        value: data?.created_at ? formatDate(data?.created_at) : "",
      },
{
        label: "Special Instructions",
        value: (
          <>
            {/* {data?.special_instructions}
            <div>{"("} <span className="text-primary cursor-pointer"  onClick={() => handelViewMoreAction(data)}>View More</span>{")"}</div> */}

            {data?.special_instructions
              ? data.special_instructions.length > 25
                ? `${data.special_instructions.substring(0, 25)}...`
                : data.special_instructions 
              : ""}

            {data?.special_instructions &&
              data.special_instructions.length > 25 && (
                <div>
                  {"("}
                  <span
                    className="text-primary cursor-pointer"
                    onClick={() => handelViewMoreAction(data)}
                  >
                    View More
                  </span>
                  {")"}
                </div>
              )}
          </>
        ),
      },
      {
        label: "Status",
        value: (
          <>
            {/* <div className="border border-danger rounded px-4 fs-11 w-auto d-inline-block">
              {data?.status}
            </div> */}
            {data?.status === "new" ? (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                New
              </span>
            ) : data?.status === "Backorder" ? (
              <span className="badge text asn-overview-status asn-overview-status-border-red rounded px-4 fs-11 w-auto d-inline-block">
                Backorder
              </span>
            ) : data?.status === "complete" ? (
              <span className="badge asn-overview-status asn-overview-status-border-green rounded px-4 fs-11 w-auto d-inline-block">
                Completed
              </span>
            ) : data?.status === "Ready to Check-in" ? (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                Ready to Check-in
              </span>
            ) : data?.status === "Ready to Unload" ? (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                Ready to Unload
              </span>
            ) : data?.status === "Ready to Receive" ? (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                Ready to Receive
              </span>
            ) : data?.status === "Ready to Putaway" ? (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                Ready to Putaway
              </span>
            ) : data?.status === "in progress" ? (
              <span className="badge asn-overview-status asn-overview-status-border-orange rounded px-4 fs-11 w-auto d-inline-block">
                In Progress
              </span>
            ) : (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                {data?.status}
              </span>
            )}
          </>
        ),
      },
      
    ],

    ASNOverviewDefault: [
      { label: "Carrier Name", value: data?.carrier?.name },
      { label: "Supplier", value: data?.supplier?.name },
      { label: "Warehouse", value: data?.warehouse?.name },
    ],
    BoxedData: [
      {
        supplier: [
          {
            label: "Supplier Name",
            value: data?.supplier?.name,
          },
          {
            label: "Address 1",
            value: data?.supplier?.address_line_1 ?? "",
          },
          {
            label: "Address 2",
            value: data?.supplier?.address_line_2 ?? "",
          },
          {
            label: "Address 3",
            value: data?.supplier?.address_line_3 ?? "",
          },
          {
            label: "Contact Name",
            value: data?.supplier_contact_name ?? "",
          },
          {
            label: "Contact Number",
            value: data?.supplier_contact_phone ?? "",
          },
        ],
      },
      {
        warehouse: [
          {
            label: "Supplier Name",
            value: data?.warehouse?.name,
          },
          {
            label: "Address 1",
            value: data?.warehouse?.address_line_1 ?? "",
          },
          {
            label: "Address 2",
            value: data?.warehouse?.address_line_2 ?? "",
          },
          {
            label: "Address 3",
            value: data?.warehouse?.address_line_3 ?? "",
          },
        ],
      },
    ],
  };

  return (
    <AsnDetail
      columns={columns}
      InboundASNOverviewData={InboundASNOverviewData}
      data={data}
      setData={setData}
      showViewModal={showViewModal}
      setViewModal={setViewModal}
      screenName={screenName}
      addUrl={addUrl}
      listUrl={listUrl}
      isHistoryEnabled={isHistoryEnabled}
      noOfrowsToDisplay={noOfrowsToDisplay}
    />
  );
}
